import { render, staticRenderFns } from "./FeeItemTaxLog.vue?vue&type=template&id=c1a5c1ec&"
import script from "./FeeItemTaxLog.vue?vue&type=script&lang=js&"
export * from "./FeeItemTaxLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports